import { createFileRoute, notFound } from '@tanstack/react-router'
import {
  getLegalDocumentContent,
  isLegalDocumentId,
} from '~/features/compliance/legal-content'
import { LegalPage } from '~/features/compliance/legal-page'
import { seo } from '~/utils/seo'

export const Route = createFileRoute('/_public/legal/$document')({
  beforeLoad: ({ params }) => {
    if (!isLegalDocumentId(params.document)) {
      throw notFound()
    }
    return { document: params.document }
  },
  head: ({ params }) => {
    if (!isLegalDocumentId(params.document)) {
      return {}
    }
    const content = getLegalDocumentContent('en', params.document)
    return seo({
      title: `${content.title} — BallPeek`,
      description: content.summary,
      pathname: `/legal/${params.document}`,
    })
  },
  component: LegalDocumentRoute,
})

function LegalDocumentRoute() {
  const { document } = Route.useRouteContext()
  return <LegalPage locale="en" document={document} />
}
